import {
  UpdateRejectionReasonDocument,
  UpdateRejectionReasonMutation,
  UpdateRejectionReasonMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateRejectionReason = () => {
  const [updateRejectionReason, { loading }] = useMutation(UpdateRejectionReasonDocument, {
    extractorFn: (data: UpdateRejectionReasonMutation) =>
      data.atsMutations.updateAtsRejectionReason,
  })

  return {
    loading,
    update(variables: UpdateRejectionReasonMutationVariables) {
      return updateRejectionReason({
        variables,
      })
    },
  }
}
